/*
 * File: /src/services/leadService.js
 * Created Date: Thursday November 4th 2021
 * Author: Nicolas Wegener, Roy Collins
 * -----
 * Last Modified: Sunday, 28th November 2021 11:32:18 pm
 * Modified By: Nicolas Wegener (wegenern@gmail.com)
 * -----
 * Copyright (c) 2021 AdBase, Inc.
 */

import { authedAxios } from '../shared/axiosWrapper';
import { AD_BASE_DISP_PATH } from '../constants';

export default {
  updateContactId(dispId, contactId) {
    return authedAxios.patch(AD_BASE_DISP_PATH + dispId, {
      contact_id: contactId,
    });
  },
  updateLeadId(dispId, leadId) {
    return authedAxios.patch(AD_BASE_DISP_PATH + dispId, {
      lead_id: leadId,
    });
  },
  updateCallResultId(dispId, callResultId) {
    return authedAxios.patch(AD_BASE_DISP_PATH + dispId, {
      call_result_id: callResultId,
    });
  },
  fetchActive(dispId) {
    return authedAxios.get(AD_BASE_DISP_PATH + dispId);
  },
};
